module.exports = __webpack_public_path__ + "static/media/play.de194509.svg";